import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';

import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { EgiAppEntity } from '@/app/platform/platform-data/models/egi-app.entity';
import { EGI_APP_ACTIONS, EgiAppActions } from '@/app/platform/platform-data/actions/types';
import { EGI_APP_QUERIES, EgiAppQueries } from '@/app/platform/platform-data/queries/types';
import { NgSelectComponent } from '@ng-select/ng-select';

@AutoUnsubscribe()
@Component({
    selector: 'egi-app-select[egiApp]',
    templateUrl: './egi-app-select.component.html',
    styleUrls: ['./egi-app-select.component.css'],
    standalone: false
})
export class EgiAppSelectComponent implements OnInit, OnDestroy {
  @Input('blacklist') set blacklistInput(v: EgiAppEntity[]) {
    this.blacklist = v.map(a => a.id);
    this.subscribeAndFilterAppsByBlacklist();
  }

  blacklist: string[] = [];

  @Input('egiApp') set egiAppInput(v: EgiAppEntity) {
    this.selectedApp = v;
  }

  @Output() egiAppChange = new EventEmitter<EgiAppEntity>();

  @ViewChild('select', { static: true }) selectRef: NgSelectComponent;

  constructor(
    @Inject(EGI_APP_ACTIONS) readonly egiAppActions: EgiAppActions,
    @Inject(EGI_APP_QUERIES) readonly egiAppQueries: EgiAppQueries
  ) {}

  private egiAppsSubscription: Subscription;

  selectedApp: EgiAppEntity;
  availableApps: EgiAppEntity[] = [];

  ngOnInit(): void {
    this.egiAppActions.loadAll();
    this.subscribeAndFilterAppsByBlacklist();
  }

  emitSelectedApp(app: EgiAppEntity) {
    this.egiAppChange.emit(app);
  }

  clear(): void {
    this.selectRef.writeValue(undefined);
  }

  ngOnDestroy(): void {
    this.egiAppsSubscription.unsubscribe();
  }

  private subscribeAndFilterAppsByBlacklist(): void {
    this.egiAppsSubscription = this.egiAppQueries.all$.subscribe(apps => {
      this.availableApps = apps.filter(a => !this.blacklist.includes(a.id));
    });
  }
}
